import React from 'react'
import moment from 'moment'
import { Formik, Form } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import * as Yup from 'yup'

import { PRIORITY_TERM, URL_CAMPAIGN_TERMS } from '../../constants'
import Button from '../buttons/buttons.component'
import { AsyncSelectInput, DatepickerInput } from '../form-components'
import { TicketSaleService } from './../../services'
import { getApiErrorMessage } from './../../services/axios.service'
import { toastActions } from '../../actions'
import {
	iFrameHelper,
	markUpgradableTicket,
	isMobile,
	sortTerminalsByPriority,
	dateHelper,
	checkURLTerm,
	debounce
} from './../../helpers'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { Creators as ProgressBarCreators } from '../../ducks/progress-bar/progress-bar'
import { Creators as TicketSaleCreators } from '../../ducks/ticket-sale/ticket-sale'
import { conexaoActions } from '../../ducks/conexao/conexaoReducer'

import {
	InputSearchCitiesContainer,
	InputSearchDateContainer,
	StyledIconFontAwesome,
	SearchContainer,
	InputSearchCity,
	InputSearchDate,
	BtnSearchTrip,
	OriginOptionLabel
} from './search-form.styles'

import { routes } from '../../constants/routes.constants'

const ALLOWED_RANGE_IN_MONTHS = 24
const DEBOUNCE_FIND_ORIGINS = 'findOrigins'
const DEBOUNCE_FIND_DESTINATIONS = 'findDestinations'

const LOCALITY_KIND = {
	CITY: 0,
	TERMINAL: 1
}

const mapLocalityOption = locality => {
	const city = locality.displayName.replace(
		new RegExp(`,\\s*${locality.stateCode}$`),
		''
	)

	return {
		value: JSON.stringify({
			id: locality.id
		}),
		id: locality.id,
		label: locality.displayName,
		city,
		kind: locality.kind,
		hasChildren: !!(locality.children && locality.children.length),
		state: locality.stateCode
	}
}

const flattenLocalities = localities =>
	localities.reduce((list, locality) => {
		list.push(mapLocalityOption(locality))

		if (locality.children && locality.children.length) {
			locality.children.forEach(child => list.push(mapLocalityOption(child)))
		}

		return list
	}, [])

const searchFormSchema = Yup.object().shape({
	tripDateGoingSearch: Yup.date(),
	tripDateReturnSearch: Yup.string().nullable(),
	origin: Yup.string('Informe o origem').required('Informe a origem'),
	destination: Yup.string('Informe o destino').required('Informe o destino')
})

class SearchFormComponent extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			formValues: {
				origin: props.origin ? props.origin.value : '',
				destination: props.destination ? props.destination.value : '',
				tripDateGoingSearch: props.tripDateGoingSearch
					? moment(props.tripDateGoingSearch).format('YYYY-MM-DD')
					: moment(dateHelper.getTomorrowDate()).format('YYYY-MM-DD'),
				tripDateReturnSearch: props.tripDateReturnSearch
					? moment(props.tripDateReturnSearch).format('YYYY-MM-DD')
					: ''
			},
			presetOrigin: null,
			presetDestination: null
		}
		this.getPlaces = this.getPlaces.bind(this)
		this.setSearchFormField = this.setSearchFormField.bind(this)
		this.getOriginList = this.getOriginList.bind(this)
		this.getDestinationList = this.getDestinationList.bind(this)
		this.alterOriginField = this.alterOriginField.bind(this)
		this.alterDestinationField = this.alterDestinationField.bind(this)
		this.renderFormik = this.renderFormik.bind(this)
		this.findOrigins = this.findOrigins.bind(this)
		this.findDestinations = this.findDestinations.bind(this)
		this.updateDestinations = this.updateDestinations.bind(this)
		this.setDestination = this.setDestination.bind(this)
		this.validateLocalities = this.validateLocalities.bind(this)
		this.searchTrips = this.searchTrips.bind(this)
		this.reverseTrip = this.reverseTrip.bind(this)
		this.isRootUrl = this.isRootUrl.bind(this)
		this.isOutsidePurchasePage = this.isOutsidePurchasePage.bind(this)
		this.redirectToTicketpurchase = this.redirectToTicketpurchase.bind(this)
		this.getRoutes = this.getRoutes.bind(this)
		this.prepareRoutesToRebooking = this.prepareRoutesToRebooking.bind(this)
		this.setCities = this.setCities.bind(this)
	}

	componentDidUpdate(prevProps) {
		const updates = {}

		if (prevProps.origin !== this.props.origin) {
			updates.origin = this.props.origin
				? this.props.origin.value
				: JSON.stringify({ id: '' })
		}

		if (prevProps.destination !== this.props.destination) {
			updates.destination = this.props.destination
				? this.props.destination.value
				: JSON.stringify({ id: '' })
		}

		const prevGoingTime = prevProps.tripDateGoingSearch
			? new Date(prevProps.tripDateGoingSearch).getTime()
			: null
		const currGoingTime = this.props.tripDateGoingSearch
			? new Date(this.props.tripDateGoingSearch).getTime()
			: null
		if (prevGoingTime !== currGoingTime) {
			updates.tripDateGoingSearch = this.props.tripDateGoingSearch
				? moment(this.props.tripDateGoingSearch).format('YYYY-MM-DD')
				: null
		}

		const prevReturnTime = prevProps.tripDateReturnSearch
			? new Date(prevProps.tripDateReturnSearch).getTime()
			: null
		const currReturnTime = this.props.tripDateReturnSearch
			? new Date(this.props.tripDateReturnSearch).getTime()
			: null
		if (prevReturnTime !== currReturnTime) {
			updates.tripDateReturnSearch = this.props.tripDateReturnSearch
				? moment(this.props.tripDateReturnSearch).format('YYYY-MM-DD')
				: null
		}

		if (Object.keys(updates).length > 0) {
			this.setState(prev => ({
				formValues: { ...prev.formValues, ...updates }
			}))
		}
	}

	async componentDidMount() {
		this.props.setTripData({
			tripsGoing: [],
			tripsReturn: []
		})

		// 7820: pré-carrega as origens (lista ranqueada pelas mais buscadas) para o dropdown
		// já exibir sugestões ao focar, sem o usuário precisar digitar.
		this.preloadOrigins()

		const tripParams = iFrameHelper.getTripParams()

		const {
			isRebooking,
			rebookingDestinationId,
			rebookingOriginId
		} = this.props.rebookingData

		if (isRebooking) {
			this.prepareRoutesToRebooking(
				rebookingOriginId,
				rebookingDestinationId
			)
		}

		const rootURL = document.location.href

		const {
			FACEBOOK_SOURCE_TAG,
			GOOGLE_SOURCE_TAG,
			TIKTOK_SOURCE_TAG
		} = URL_CAMPAIGN_TERMS

		if (
			checkURLTerm(rootURL, FACEBOOK_SOURCE_TAG) ||
			checkURLTerm(rootURL, GOOGLE_SOURCE_TAG) ||
			checkURLTerm(rootURL, TIKTOK_SOURCE_TAG)
		) {
			this.setCampaignParams(tripParams.campaignCode, rootURL)
		}

		if (!tripParams.isValidParameters) {
			const {
				origin,
				destination,
				tripDateGoingSearch,
				tripDateReturnSearch,
				destinationList,
				rebookingData
			} = this.props

			let defaultDateGoingSearch = dateHelper.getTomorrowDate()

			if (tripDateGoingSearch) {
				defaultDateGoingSearch = tripDateGoingSearch
			}

			this.props.setTripDateGoingSearch(defaultDateGoingSearch)

			if (!origin || !destination || !destinationList) {
				return
			}

			const tripDateReturnValues =
				!isNaN(Date.parse(tripDateReturnSearch)) &&
					!rebookingData.isRebooking
					? tripDateReturnSearch
					: null

			this.props.setDestinationList(destinationList)
			this.props.setTripDateReturnSearch(tripDateReturnValues)

			this.setSearchFormField({
				originId: JSON.parse(origin.value).id,
				destinationId: JSON.parse(destination.value).id,
				tripDateGoingSearch: defaultDateGoingSearch,
				tripDateReturnSearch: tripDateReturnValues
			})

			return
		}

		this.searchTrips({
			...tripParams,
			origin: JSON.stringify({
				id: tripParams.originId
			}),
			destination: JSON.stringify({
				id: tripParams.destinationId
			})
		})
	}

	resolveCampaign(rootURL, urlParams) {
		const campaignSources = [
			{
				sourceTag: URL_CAMPAIGN_TERMS.FACEBOOK_SOURCE_TAG,
				campaignTag: URL_CAMPAIGN_TERMS.FACEBOOK_CAMPAIGN_TAG,
				fallbackTag: URL_CAMPAIGN_TERMS.FACEBOOK_SOURCE_TAG,
				source: URL_CAMPAIGN_TERMS.FACEBOOK_SOURCE
			},
			{
				sourceTag: URL_CAMPAIGN_TERMS.GOOGLE_SOURCE_TAG,
				campaignTag: URL_CAMPAIGN_TERMS.GOOGLE_CAMPAIGN_TAG,
				fallbackTag: null,
				source: URL_CAMPAIGN_TERMS.GOOGLE_SOURCE
			},
			{
				sourceTag: URL_CAMPAIGN_TERMS.TIKTOK_SOURCE_TAG,
				campaignTag: URL_CAMPAIGN_TERMS.TIKTOK_CAMPAIGN_TAG,
				fallbackTag: URL_CAMPAIGN_TERMS.TIKTOK_SOURCE_TAG,
				source: URL_CAMPAIGN_TERMS.TIKTOK_SOURCE
			}
		]

		for (const {
			sourceTag,
			campaignTag,
			fallbackTag,
			source
		} of campaignSources) {
			if (!checkURLTerm(rootURL, sourceTag)) continue

			const code =
				urlParams.get(campaignTag.toLowerCase()) ||
				(fallbackTag && urlParams.get(fallbackTag.toLowerCase()))

			return { campaignCode: code, sourceCampaign: source }
		}

		return null
	}

	setCampaignParams(code, rootURL) {
		const urlParams = new URLSearchParams(new URL(rootURL).search)

		const resolved = this.resolveCampaign(rootURL, urlParams)

		const campaignCode = resolved
			? resolved.campaignCode
			: code || URL_CAMPAIGN_TERMS.NO_CAMPAIGN_CODE

		const sourceCampaign = resolved
			? resolved.sourceCampaign
			: URL_CAMPAIGN_TERMS.NO_SOURCE_CAMPAIGN

		this.props.setRootURL(rootURL)
		this.props.setCampaignCode(campaignCode)
		this.props.setCampaignSource(sourceCampaign)
	}

	async getOriginList(term) {
		const { data } = await TicketSaleService.getOrigins(term)
		const origins = data ? data.items : []

		if (!origins || !origins.length) return []

		return flattenLocalities(origins)
	}

	// 7820: busca a lista inicial de origens (termo vazio => backend devolve a lista ranqueada
	// pelas mais buscadas) e a guarda no estado para o AsyncSelect exibir sem digitar. Só busca
	// quando ainda não há lista carregada, para não sobrescrever origens de remarcação/URL.
	async preloadOrigins() {
		if (this.props.originList && this.props.originList.length) return

		const originList = await this.getOriginList('')

		if (originList && originList.length) {
			this.props.setOriginList(originList)
		}
	}

	formatLocalityOptionLabel(option, { context }) {
		const isMenu = context === 'menu'
		const isTerminal = isMenu && option.kind === LOCALITY_KIND.TERMINAL
		const isCity = isMenu && option.kind === LOCALITY_KIND.CITY

		return (
			<OriginOptionLabel isTerminal={isTerminal} isCity={isCity}>
				{option.label}
			</OriginOptionLabel>
		)
	}

	async getDestinationList(origin, term) {
		try {
			const originId = JSON.parse(origin.value).id
			const { data } = await TicketSaleService.getDestinations(originId, term)
			const destinationsFound = data ? data.items : []

			const destinations = flattenLocalities(destinationsFound)

			return sortTerminalsByPriority(destinations, PRIORITY_TERM)
		} catch (error) {
			if (!getApiErrorMessage(error)) {
				this.props.toastWarning({
					message: 'Ocorreu um erro ao buscar lista de destinos.'
				})
			}

			return []
		}
	}

	findDestinations(inputValue, callback) {
		if (
			!inputValue ||
			inputValue.toUpperCase() === this.props.searchDestinationTerm
		) {
			callback(this.props.destinationList)
			return
		}

		if (!this.props.origin) {
			callback([])
			return
		}

		debounce(
			1000,
			isCurrent => {
				if (!isCurrent()) return

				const term = inputValue.toUpperCase()

				this.getDestinationList(this.props.origin, term).then(
					destinationListFound => {
						if (!isCurrent()) return

						this.props.setSearchDestinationTerm(term)
						this.props.setDestinationList(destinationListFound)
						callback(destinationListFound)
					}
				)
			},
			DEBOUNCE_FIND_DESTINATIONS
		)
	}

	findOrigins(inputValue, callback) {
		if (
			!inputValue ||
			inputValue.toUpperCase() === this.props.searchOriginTerm
		) {
			callback(this.props.originList)
			return
		}

		debounce(
			1000,
			isCurrent => {
				if (!isCurrent()) return

				this.props.setDestination(null)
				this.props.setDestinationList([])

				this.alterDestinationField(
					JSON.stringify({
						id: ''
					})
				)

				const term = inputValue.toUpperCase()

				this.getOriginList(term).then(originListFound => {
					if (!isCurrent()) return

					this.props.setSearchOriginTerm(term)
					this.props.setOriginList(originListFound)
					callback(originListFound)
				})
			},
			DEBOUNCE_FIND_ORIGINS
		)
	}

	setDestination(destination) {
		if (this.state.presetDestination) {
			this.setState({ presetDestination: null })
		}

		if (!destination) return

		const destinationId = JSON.parse(destination).id

		const selectedDestination = this.props.destinationList.find(
			({ value }) => JSON.parse(value).id === destinationId
		)

		if (selectedDestination) {
			this.props.setDestination(selectedDestination)
		}
	}

	validateLocalities() {
		const { origin, destination, tripDateGoingSearch } = this.props

		if (!origin || !destination || !tripDateGoingSearch) {
			this.props.toastWarning({
				message: 'Escolha origem, destino e data de ida'
			})
			return
		}

		if (origin.label === destination.label) {
			this.props.toastWarning({
				message: 'A origem e o destino devem ser distintos'
			})
			return
		}

		this.props.setEtapaPagamento(false)

		this.searchTrips(this.state.formValues)
	}

	redirectToTicketpurchase() {
		const {
			origin,
			destination,
			tripDateGoingSearch,
			tripDateReturnSearch,
			history
		} = this.props

		const tripDateReturnValid = tripDateReturnSearch
			? moment(tripDateReturnSearch).format('YYYY/MM/DD')
			: null

		let url = routes.COMPRA_DE_PASSAGEM

		if (document.location.pathname.includes(routes.PLANALTO_SITE)) {
			url +=
				`?IdOrigem=${origin.id}` +
				`&IdDestino=${destination.id}` +
				`&DestinoCity=${destination.city}` +
				`&OriginCity=${origin.city}` +
				`&Empresa=${destination.busCompany}` +
				`&DataIda=${moment(tripDateGoingSearch).format('YYYY/MM/DD')}` +
				`&DataVolta=${tripDateReturnValid}` +
				`&hasChildren=${origin.hasChildren}`
		}

		history.push(url)
	}

	isRootUrl() {
		return document.location.pathname === '/'
	}

	isOutsidePurchasePage() {
		return !document.location.pathname.includes(routes.COMPRA_DE_PASSAGEM)
	}

	async searchTrips(values) {
		const {
			origin,
			destination,
			destinationCity,
			tripDateGoingSearch,
			tripDateReturnSearch
		} = values

		if (!origin || !destination) return

		const originId = JSON.parse(origin).id
		const destinationId = JSON.parse(destination).id || destinationCity

		if (
			!originId ||
			(!destinationId && !destinationCity) ||
			!this.props.originList.length
		) {
			return
		}

		if (this.isRootUrl() || this.isOutsidePurchasePage()) {
			this.redirectToTicketpurchase()
			this.props.resetRebookingData()
		}

		try {
			let { origin, destination, destinationList } = await this.getPlaces(
				originId,
				destinationId
			)

			if (!origin || !destination) {
				this.props.toastWarning({
					message: 'Origem ou destino não encontrados.'
				})

				return
			}

			this.props.resetConexaoState()

			await this.props.performSearchTrips({
				origin,
				originId,
				destination,
				destinationId,
				tripDateGoingSearch,
				tripDateReturnSearch,
				originList: this.props.originList
			})

			if (!this.props.origin) {
				this.props.setTripDateReturnSearch(tripDateReturnSearch)
				this.props.setTripDateGoingSearch(tripDateGoingSearch)
				this.props.setDestinationList(destinationList)
				this.props.setOrigin(origin)
				this.props.setDestination(destination)

				this.setSearchFormField({
					originId,
					destinationId,
					tripDateGoingSearch,
					tripDateReturnSearch
				})
			}

		} catch (error) {
			if (!getApiErrorMessage(error)) {
				this.props.toastWarning({
					message: 'Ocorreu um erro ao tentar buscar as viagens'
				})
			}

			return
		}
	}

	async getPlaces(originId, destinationId) {
		const origin = this.props.originList.find(
			origin => JSON.parse(origin.value).id === originId
		)

		if (!origin) return {}

		const currentDestination = this.props.destination
		const currentDestinationIsSelected =
			currentDestination &&
			JSON.parse(currentDestination.value).id === destinationId

		if (currentDestinationIsSelected) {
			return {
				origin,
				destination: currentDestination,
				destinationList: this.props.destinationList
			}
		}

		const destinationList = await this.getDestinationList(origin)

		if (!destinationList) return { origin, destinationList: [] }

		const destination = destinationList.find(
			destination => JSON.parse(destination.value).id === destinationId
		)

		if (!destination) return { origin, destinationList }

		return { origin, destination, destinationList }
	}

	setSearchFormField({
		originId,
		destinationId,
		tripDateGoingSearch,
		tripDateReturnSearch
	}) {
		this.setState(prev => ({
			formValues: {
				...prev.formValues,
				origin: JSON.stringify({ id: originId }),
				destination: JSON.stringify({ id: destinationId }),
				tripDateGoingSearch: tripDateGoingSearch
					? moment(tripDateGoingSearch).format('YYYY-MM-DD')
					: null,
				...(tripDateReturnSearch && {
					tripDateReturnSearch: moment(tripDateReturnSearch).format('YYYY-MM-DD')
				})
			}
		}))
	}

	filterBusByFreeSeats(ticketRoutes) {
		return ticketRoutes
			.filter(route => route.freeSeats > 0)
			.map(markUpgradableTicket)
	}

	setCities({ destination, origin, destinations }) {
		this.props.setDestinationList(destinations)
		this.props.setDestination(destination)
		this.props.setOrigin(origin)

		this.alterOriginField(origin.value)
		this.alterDestinationField(destination.value)
	}

	async reverseTrip() {
		const {
			origin,
			destination,
			showLoading,
			hideLoading,
			toastWarning
		} = this.props

		if (this.props.rebookingData.isRebooking) {
			toastWarning({
				message: 'Em remarcação não é possível inverter origem e destino.'
			})
			return
		}

		if (!origin || !destination) {
			toastWarning({
				message: 'Escolha origem e destino para poder inverter'
			})
			return
		}

		showLoading()

		try {
			const { data } = await TicketSaleService.swapLocalities({
				currentOriginId: JSON.parse(origin.value).id,
				currentDestinationId: JSON.parse(destination.value).id
			})

			if (!data || !data.origin || !data.destination) {
				toastWarning({
					message: 'Não foi possível inverter origem e destino.'
				})
				return
			}

			const newOrigin = mapLocalityOption(data.origin)
			const newDestination = mapLocalityOption(data.destination)

			// O AsyncSelectInput só exibe o valor selecionado corretamente se
			// ele já estiver presente na lista de opções - por isso as listas
			// (origins/destinations) precisam ser aplicadas antes do value.
			this.props.setOriginList(flattenLocalities(data.origins || []))
			this.props.setDestinationList(flattenLocalities(data.destinations || []))

			this.props.setOrigin(newOrigin)
			this.props.setDestination(newDestination)

			this.setState({
				presetOrigin: newOrigin,
				presetDestination: newDestination
			})

			this.alterOriginField(newOrigin.value)
			this.alterDestinationField(newDestination.value)

		} catch (error) {
			toastWarning({
				message: 'Ocorreu um erro ao tentar inverter origem e destino.'
			})
		} finally {
			hideLoading()
		}
	}

	getRoutes(cityId, routes) {
		return routes.find(routeFound => routeFound.id === cityId)
	}

	async prepareRoutesToRebooking(originId, destinationId) {
		const newOrigin = this.getRoutes(originId, this.props.originList)

		let destinationsFound = await this.getDestinationList(newOrigin)

		const newDestination = this.getRoutes(destinationId, destinationsFound)

		this.setCities({
			destination: newDestination,
			destinations: destinationsFound,
			origin: newOrigin
		})
	}

	async updateDestinations(newOriginLocality) {
		if (this.state.presetOrigin) {
			this.setState({ presetOrigin: null })
		}

		if (!newOriginLocality) {
			return
		}

		let newOriginId

		try {
			newOriginId = JSON.parse(newOriginLocality).id
		} catch (error) {
			return
		}

		const currentOriginId = this.props.origin
			? JSON.parse(this.props.origin.value).id
			: null

		if (newOriginId === currentOriginId) {
			return
		}

		const selectedOrigin = this.props.originList.find(({ value }) => {
			try {
				return JSON.parse(value).id === newOriginId
			} catch (error) {
				return false
			}
		})

		if (!selectedOrigin) {
			return
		}

		const destinationListReadyToShow = await this.getDestinationList(
			selectedOrigin
		)

		if (!destinationListReadyToShow || !destinationListReadyToShow.length)
			return

		const currentDestination = this.props.destination
		const currentDestinationIsValid =
			currentDestination &&
			destinationListReadyToShow.some(
				dest =>
					JSON.parse(dest.value).id === JSON.parse(currentDestination.value).id
			)

		if (!currentDestinationIsValid) {
			this.alterDestinationField(
				JSON.stringify({
					id: ''
				})
			)
		}

		this.props.setOrigin(selectedOrigin)
		this.props.setDestinationList(destinationListReadyToShow)
	}

	alterOriginField(value) {
		this.setState(prev => ({
			formValues: { ...prev.formValues, origin: value }
		}))
	}

	alterDestinationField(value) {
		this.setState(prev => ({
			formValues: { ...prev.formValues, destination: value }
		}))
	}

	renderFormik(props) {
		const isRootUrlState = this.isRootUrl()
		const isMobileState = isMobile()
		const { isIframe } = this.props

		return (
			<Form noValidate>
				<SearchContainer
					isrooturl={isRootUrlState}
					isIframe={isIframe}
				>
					<InputSearchCitiesContainer isrooturl={isRootUrlState} isIframe={isIframe}>
						<InputSearchCity>
							<AsyncSelectInput
								{...props}
								id="origin"
								placeholder={'Origem'}
								defaultOptions={this.props.originList}
								defaultValue={this.state.presetOrigin}
								loadOptions={this.findOrigins}
								onValueChange={this.updateDestinations}
								disabled={this.props.rebookingData.isRebooking}
								formatOptionLabel={this.formatLocalityOptionLabel}
							/>
						</InputSearchCity>
						<StyledIconFontAwesome
							name="exchange"
							title="Inverter destino"
							onClick={this.reverseTrip}
							id="ico-reverse"
							isrooturl={isRootUrlState}
							isIframe={isIframe}
						/>
						<InputSearchCity>
							<AsyncSelectInput
								{...props}
								id="destination"
								placeholder="Destino"
								defaultOptions={this.props.destinationList}
								defaultValue={this.state.presetDestination}
								loadOptions={this.findDestinations}
								onValueChange={this.setDestination}
								disabled={this.props.rebookingData.isRebooking}
								formatOptionLabel={this.formatLocalityOptionLabel}
							/>
						</InputSearchCity>
					</InputSearchCitiesContainer>
					<InputSearchDateContainer isIframe={isIframe}>
						<InputSearchDate>
							<DatepickerInput
								{...props}
								id="tripDateGoingSearch"
								placeholder="Data da ida"
								isOutsideRange={value => {
									const tripDateReturnSearch = this.props
										.tripDateReturnSearch
									return (
										value.isBefore(moment().startOf('day')) ||
										value.isAfter(
											moment()
												.startOf('day')
												.add(ALLOWED_RANGE_IN_MONTHS, 'M')
										) ||
										(tripDateReturnSearch &&
											value.isAfter(
												moment(
													tripDateReturnSearch,
													'YYYY-MM-DD'
												).add(1, 'days')
											))
									)
								}}
								onValueChange={this.props.setTripDateGoingSearch}
							/>
						</InputSearchDate>
						<InputSearchDate>
							<DatepickerInput
								{...props}
								showClearDate
								id="tripDateReturnSearch"
								placeholder="Data da volta (opcional)"
								isOutsideRange={value => {
									const tripDateGoingSearch = this.props
										.tripDateGoingSearch
									return (
										value.isBefore(moment().startOf('day')) ||
										(tripDateGoingSearch &&
											value.isBefore(
												moment(tripDateGoingSearch, 'YYYY-MM-DD')
											))
									)
								}}
								onValueChange={this.props.setTripDateReturnSearch}
								disabled={this.props.rebookingData.isRebooking}
							/>
						</InputSearchDate>
					</InputSearchDateContainer>
					<BtnSearchTrip isrooturl={isRootUrlState.toString()} isIframe={isIframe}>
						<Button
							isIframe={isIframe}
							primary={isRootUrlState.toString()}
							secondary={(!isRootUrlState).toString()}
							type="button"
							onClick={this.validateLocalities}
							height={isMobileState ? null : '4.5rem'}>
							Buscar
						</Button>
					</BtnSearchTrip>
				</SearchContainer>
			</Form>
		)
	}

	render() {
		return (
			<Formik
				enableReinitialize
				initialValues={this.state.formValues}
				validationSchema={searchFormSchema}
				render={this.renderFormik}
				onSubmit={this.searchTrips}
			/>
		)
	}
}

const mapStateToProps = store => {
	return {
		user: store.user,
		origin: store.ticketSale.origin,
		originList: store.ticketSale.originList,
		searchOriginTerm: store.ticketSale.searchOriginTerm,
		destination: store.ticketSale.destination,
		destinationList: store.ticketSale.destinationList,
		searchDestinationTerm: store.ticketSale.searchDestinationTerm,
		tripDateGoingSearch: store.ticketSale.tripDateGoingSearch,
		tripDateReturnSearch: store.ticketSale.tripDateReturnSearch,
		rebookingData: store.ticketSale.rebookingData,
		campaignCode: store.ticketSale.campaignCode
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastWarning: toastActions.warning,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			setOriginPortal: TicketSaleCreators.setOriginPortal,
			resetConexaoState: conexaoActions.resetConexaoState,
			setTripData: TicketSaleCreators.setTripData,
			setOrigin: TicketSaleCreators.setOrigin,
			setOriginList: TicketSaleCreators.setOriginList,
			setSearchOriginTerm: TicketSaleCreators.setSearchOriginTerm,
			setDestination: TicketSaleCreators.setDestination,
			setDestinationList: TicketSaleCreators.setDestinationList,
			setSearchDestinationTerm: TicketSaleCreators.setSearchDestinationTerm,
			setTripDateGoingSearch: TicketSaleCreators.setTripDateGoingSearch,
			setTripDateReturnSearch: TicketSaleCreators.setTripDateReturnSearch,
			setEtapaPagamento: TicketSaleCreators.setEtapaPagamento,
			resetRebookingData: TicketSaleCreators.resetRebookingData,
			setCampaignCode: TicketSaleCreators.setCampaignCode,
			setRootURL: TicketSaleCreators.setRootURL,
			setCampaignSource: TicketSaleCreators.setCampaignSource,
			performSearchTrips: TicketSaleCreators.performSearchTrips
		},
		dispatch
	)

export const SearchForm = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SearchFormComponent)
)

export default SearchForm
